import RcTableViewUtils from "../../../../../shared/table/RcTableViewUtils";


import MC from "@/domain/session/MC.js";
import ContentUtils from '@/utils/ContentUtils.js';
import StringUtils from '@/utils/StringUtils.js';

import BoxDisplayRow from "@/portals/shared/cell/box/BoxDisplayRow";
import LabelValueDisplayRow from "@/portals/shared/cell/label/LabelValueDisplayRow";
import RowDisplayRow from "@/portals/shared/cell/row/RowDisplayRow";
import StatusDisplayRow from '@/portals/shared/cell/status/StatusDisplayRow';
import StringDisplayRow from "@/portals/shared/cell/string/StringDisplayRow";
import TitleDisplayRow from "@/portals/shared/cell/title/TitleDisplayRow";
import ButtonDisplayRow from "../../../../../shared/cell/button/ButtonDisplayRow";
import ImageDisplayRow from "../../../../../shared/cell/image/ImageDisplayRow";
import SpacerDisplayRow from "../../../../../shared/cell/spacer/SpacerDisplayRow";

export default class DisplayViewUtils extends RcTableViewUtils {

  constructor(model, tableData) {
    super(model, tableData);
    this.MC = new MC();
    this.Contents = ContentUtils;
    this.Strings = new StringUtils();
  }

  start() {
    super.startV2("Company");
  }

  renderHeader() {
  }

  renderFooter() {
  }

  renderBody() {
    let company = this.model().company();
    let features = company.features().find();
    let address = company.address().find();
    let hqAddress = company.addressHq().find();
    let status = new StatusDisplayRow().withLabelWidth(0);
    status.withValue("ExpireNext").withObject("This section is incomplete. Without this, inspections will not be valid")
    if (address.isComplete()) {
      status = null;
    }

    let emailString = company.email().split(",");
    let emailDefectsString = company.emailDefects().split(",");
    let emailEquipmentString = company.emailEquipment().split(",");
    let emailEquipmentDefectsString = company.emailEquipmentDefects().split(",");

    emailString = emailString.join(', ');
    emailDefectsString = emailDefectsString.join(', ');
    emailEquipmentString = emailEquipmentString.join(', ');
    emailEquipmentDefectsString = emailEquipmentDefectsString.join(', ');

    let hosBeforeStart = new LabelValueDisplayRow().withLabel("Hours of Service Mandatory").withLabelWidth(6).withValue(company.timesheetStartedBeforeInspection() ? 'On' : 'Off').withWidth(15).withHint("Requires Commercial Drivers to start their Hours of Service before an inspection.  Non-Commercial Drivers are not affected by this setting as they do not require Hours of Service. ***This requires an app update to take effect.  Stay tuned.");
    if (!features.allowsTimesheets()) {
      hosBeforeStart = new SpacerDisplayRow();
    }
    let linkString = StringUtils.format("https://www.readychek.app/service/v1/api/rest/inspections?key={0}&time=today&email={1}", [company.apiKey(), this.domain().session().user().email()]);
    if (!this.domain().client().isProduction()) {
      linkString = StringUtils.format("http://localhost:8080/service/v1/api/rest/inspections?key={0}&time=today&email={1}", [company.apiKey(), this.domain().session().user().email()]);
    }

    let equipmentInspectionEmailRow = new RowDisplayRow();
    let equipmentInspectionDefectEmailRow = new RowDisplayRow();

    if (features.allowsEquipment()) {
      equipmentInspectionEmailRow
        .withChild(new LabelValueDisplayRow().withLabel("Equipment").withValue(emailEquipmentString.length == 0 ? "[Not Set]" : emailEquipmentString).withWidth(13).withLabelWidth(4).withHint("A copy of All equipment inspections will be sent to each address"))
        .withChild(new ButtonDisplayRow().withWidth(2).withName("Update").withField("Update").withObject("Company.EmailEquipment"));
      equipmentInspectionDefectEmailRow
        .withChild(new LabelValueDisplayRow().withLabel("Equipment").withValue(emailEquipmentDefectsString.length == 0 ? "[Not Set]" : emailEquipmentDefectsString).withWidth(13).withLabelWidth(4).withHint("A copy of equipment inspections with Defects will be sent to each address"))
        .withChild(new ButtonDisplayRow().withWidth(2).withName("Update").withField("Update").withObject("Company.EmailEquipmentDefects"));
    }

    let bodyRow = new RowDisplayRow()
      .withChild(new BoxDisplayRow().withWidth(8).withBorder()
        .withChild(new TitleDisplayRow().withTitle("Commercially Registered Company Details").withSubtitle(true))
        .withChild(new LabelValueDisplayRow().withLabel("Company Name").withValue(company.name()))
        .withChild(new LabelValueDisplayRow().withLabel("Phone #").withValue(company.phone()))
        .withChild(new LabelValueDisplayRow().withLabel("Registration #").withValue(company.cvorNumber()))
        .withChild(new LabelValueDisplayRow().withLabel("Registration/ CVOR Date").withValue(company.registrationDateV2().displayAs_YYYY_MM_DD()))
        .withChild(new SpacerDisplayRow())
        .withChild(new SpacerDisplayRow())
        .withChild(new RowDisplayRow()
          .withChild(new SpacerDisplayRow().withWidth(10))
          .withChild(new ButtonDisplayRow().withWidth(5).withName("Update").withField("Update").withObject("Company"))
        )
      )
      .withChild(new BoxDisplayRow().withWidth(7).withBorder()
        .withChild(new TitleDisplayRow().withTitle("Registered Address").withSubtitle(true))
        .withChild(new StringDisplayRow().withValue("It is important that this company information matches the information on your commercial motor vehicle registration. If you are operating as a CVOR company, this information must match your CVOR documentation.").withWidth(15).withFontSize("small").withAlignLeft())
        .withChild(new LabelValueDisplayRow().withLabel("No. and Street").withValue(address.street()))
        .withChild(new LabelValueDisplayRow().withLabel("City").withValue(address.city()))
        .withChild(new LabelValueDisplayRow().withLabel("Jurisdiction").withValue(address.province()))
        .withChild(new LabelValueDisplayRow().withLabel("Country").withValue(address.country()))
        .withChild(new LabelValueDisplayRow().withLabel("Postal Code").withValue(address.postal()))
        .withChild(new RowDisplayRow()
          .withChild(new SpacerDisplayRow().withWidth(10))
          .withChild(new ButtonDisplayRow().withWidth(5).withName("Update").withField("Update").withObject("Company.Address"))
        )
      )
      .withChild(new BoxDisplayRow().withBorder().withWidth(10).withChildren([
        new TitleDisplayRow().withTitle("HQ Button Address").withSubtitle(true).withWidth(15),
        new StringDisplayRow().withValue("By setting this value your drivers will be able to complete the Inspection quickly and accurately in the App. This value should represent the address where the majority of the drivers will start their day.").withWidth(15).withFontSize("small").withAlignLeft(),
        new RowDisplayRow().withWidth(15).withChildren([
          new BoxDisplayRow().withWidth(6).withChildren([
            new ImageDisplayRow().withHqDemoButton().withWidth(15)
          ]),
          new SpacerDisplayRow().withWidth(1),
          new BoxDisplayRow().withWidth(7).withChildren([
            new LabelValueDisplayRow().withLabel("No. and Street").withValue(hqAddress.street()).withWidth(15).withLabelWidth(6),
            new LabelValueDisplayRow().withLabel("City").withValue(hqAddress.city()).withWidth(15).withLabelWidth(6),
            new LabelValueDisplayRow().withLabel("Jurisdiction").withValue(hqAddress.province()).withWidth(15).withLabelWidth(6),
            new LabelValueDisplayRow().withLabel("Country").withValue(hqAddress.country()).withWidth(15).withLabelWidth(6),
            new LabelValueDisplayRow().withLabel("Postal Code").withValue(hqAddress.postal()).withWidth(15).withLabelWidth(6),
          ])
        ]),
        new RowDisplayRow()
          .withChild(new SpacerDisplayRow().withWidth(11))
          .withChild(new ButtonDisplayRow().withWidth(4).withName("Update").withField("Update").withObject("Company.hqAddress"))
      ]))
      .withChild(new RowDisplayRow().withBorder().withWidth(5).withChildren([
        new BoxDisplayRow().withWidth(15).withChildren([
          new TitleDisplayRow().withTitle("Global User Settings").withSubtitle(true).withWidth(15),
          new StringDisplayRow().withAlignLeft().withFontSize("small").withValue("These settings are defaults for all specified drivers.   Once individual user preferences are available, it will be possible to create specific user exceptions"),
          new LabelValueDisplayRow().withLabel("Allow Profile Updates").withLabelWidth(6).withValue(company.userCanUpdateProfile() ? 'On' : 'Off').withWidth(15).withHint("Allows all users to update their name, email, phone, address and driver's license information"),
          new LabelValueDisplayRow().withLabel("Drivers Receive Inspection Email").withLabelWidth(6).withValue(company.emailInspectionsToDriver() ? 'On' : 'Off').withWidth(15).withHint("After completing an inspection, drivers should receive an email to their sign in email address with inspection details, and the PDF of the inspection just completed"),
          hosBeforeStart,
          new RowDisplayRow()
            .withChild(new SpacerDisplayRow().withWidth(10))
            .withChild(new ButtonDisplayRow().withWidth(5).withName("Update").withField("Update").withObject("Company.ProfileUpdate"))
        ]),
      ]))
      .withChild(new RowDisplayRow().withWidth(15).withBorder().withChildren([
        new BoxDisplayRow().withWidth(8).withBorder().withChildren([
          new TitleDisplayRow().withTitle("Email All Inspections To").withSubtitle(true),
          new RowDisplayRow()
            .withChild(new LabelValueDisplayRow().withLabel("Vehicles").withValue(emailString.length == 0 ? "[Not Set]" : emailString).withWidth(13).withLabelWidth(4).withHint("A copy of All vehicle inspections will be sent to each address"))
            .withChild(new ButtonDisplayRow().withWidth(2).withName("Update").withField("Update").withObject("Company.Email")),

          equipmentInspectionEmailRow,

        ]),
        new BoxDisplayRow().withWidth(7).withBorder().withChildren([
          new TitleDisplayRow().withTitle("Email Inspections with Defects To").withSubtitle(true),
          new RowDisplayRow()
            .withChild(new LabelValueDisplayRow().withLabel("Vehicles").withValue(emailDefectsString.length == 0 ? "[Not Set]" : emailDefectsString).withWidth(13).withLabelWidth(4).withHint("A copy of inspections with Defects will be sent to each address"))
            .withChild(new ButtonDisplayRow().withWidth(2).withName("Update").withField("Update").withObject("Company.EmailDefects")),
          equipmentInspectionDefectEmailRow,
        ])
      ]))
      .withChild(new BoxDisplayRow().withWidth(15).withBorder().withChildren([
        new BoxDisplayRow().withWidth(15).withChildren([
          new TitleDisplayRow().withTitle("Api Key").withSubtitle(false).withWidth(15).withSubtitle(true),
          new LabelValueDisplayRow().withLabel("Api Key").withValue(company.apiKey()).withWidth(15),
          new StringDisplayRow().withValue("This API key can be used to extract inspection information from ReadyChek. An example API call to return all inspections created today:").withWidth(15).withAlignLeft(),
          new StringDisplayRow().withValue("curl " + linkString).withWidth(15).withAlignLeft(),
          new StringDisplayRow().withValue("or by clicking on this API Test Link").withWidth(15).withClickable(true).withField("FollowLink").withObject(linkString).withAlignLeft(),
          new StringDisplayRow().withValue("Please note: The endpoint /inspections is the only one available at this time.").withWidth(15).withFontSize("xsmall").withAlignLeft()
        ])
      ]));

    this.addBody(new RowDisplayRow()
      .withChild(new SpacerDisplayRow().withWidth(2))
      .withChild(new BoxDisplayRow().withWidth(11).withBorder()
        .withChild(new TitleDisplayRow().withTitle("Company Details"))
        .withChild(bodyRow)
      )
      .withChild(new SpacerDisplayRow().withWidth(2))
    );

  }

}